import { DocumentGroup } from "@ippon/shared-components";

export const propertyDocumentGroups: DocumentGroup[] = [
  {
    key: "registration",
    label: "登記、測量関連",
    categories: [
      { key: "kozu", label: "公図" },
      { key: "land_registry", label: "登記簿謄本（土地）" },
      { key: "building_registry", label: "登記簿謄本（建物）" },
      { key: "survey_map", label: "地積測量図" },
      { key: "boundary_confirmation_docs", label: "境界確定書" },
      { key: "encroachment_memo_docs", label: "越境覚書" },
    ],
  },
  {
    key: "construction",
    label: "建築関連",
    categories: [
      { key: "construction_notice", label: "建築確認通知書" },
      { key: "inspection_certificate_docs", label: "検査済証" },
      { key: "completion_drawing", label: "竣工図" },
      { key: "structural_calculation", label: "構造計算書" },
    ],
  },
  {
    key: "sales",
    label: "売買、契約関連",
    categories: [
      { key: "sales_contract", label: "売買契約書" },
      { key: "important_matters", label: "重要事項説明書" },
      { key: "owner_change_notice", label: "所有者変更通知書（承継同意書）" },
    ],
  },
  {
    key: "due_diligence",
    label: "デューデリジェンス関連",
    categories: [
      { key: "appraisal_report", label: "不動産鑑定書" },
      { key: "engineering_report", label: "エンジニアリングレポート" },
    ],
  },
  {
    key: "management",
    label: "管理契約関連",
    categories: [
      {
        key: "property_management_contract",
        label: "プロパティ・マネジメント契約書",
      },
      {
        key: "building_management_contract",
        label: "ビル・マネジメント契約書",
      },
      { key: "electricity_contract", label: "電気需給契約書" },
      { key: "industrial_waste_contract", label: "産業廃棄物処理委託契約書" },
      {
        key: "general_waste_contract",
        label: "一般廃棄物の収集・運搬等に関する契約書",
      },
      {
        key: "electrical_equipment_contract",
        label: "自家用電気工作物の保安管理業務に関する委託契約書",
      },
      { key: "insurance_certificate_docs", label: "保険証書" },
    ],
  },
  {
    key: "fire_prevention",
    label: "消防、防災関連",
    categories: [
      { key: "fire_prevention_plan", label: "消防計画作成届出書" },
      {
        key: "overall_fire_prevention_plan",
        label: "全体についての消防計画作成届出書",
      },
      {
        key: "chief_fire_manager_appointment",
        label: "統括防火管理者選任届出書",
      },
      { key: "fire_manager_appointment", label: "防火管理者選任届出書" },
      { key: "specific_building_change", label: "特定建築物変更届" },
      { key: "fire_manager_delegation", label: "防火管理者の業務委任覚書書" },
    ],
  },
  {
    key: "trust",
    label: "信託関連",
    categories: [
      { key: "trust_contract", label: "不動産管理処分信託契約書" },
      { key: "trust_certificate", label: "不動産信託受益権証書" },
      {
        key: "trust_transfer_consent",
        label: "不動産管理処分信託受益権譲渡承諾書兼依頼書兼承諾書",
      },
    ],
  },
];
